<template>
    <div class="col-12">
      <div class="container-table-servs">
        <q-card>
          <q-table
            :data="serviciosEntidad"
            :columns="columns"
            row-key="nivel"
            :filter="filter"
            :pagination.sync="pagination"
            data-cy="list-servicios"
            title="Servicios digitales"
          >
            <template v-slot:top-right>
              <div>
                <q-input
                  dense
                  debounce="100"
                  v-model="filter"
                  outlined
                  stack-label
                  placeholder="Escriba para buscar"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
            </template>
            <template v-slot:body="props">
              <q-tr
                :props="props"
              >
                <q-td key="nivel1" :props="props">
                  {{ props.row.nivel1 }}
                </q-td>
                <q-td key="nivel2" :props="props">
                  {{ props.row.nivel2 }}
                </q-td>
                <q-td key="nivel3Titulo" :props="props">
                  {{ props.row.nivel3Titulo }}
                </q-td>
                <q-td key="contratado" :props="props">
                    <q-toggle
                      color="primary"
                      v-model="props.row.contratado"
                    />
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </q-card>
      </div>
    </div>
</template>

<script>
import Loading from '@/components/shared/mixins/Loading.js';
import {
  QTable,
  QCard,
  QTr,
  QTd,
  QToggle
} from 'quasar';

export default {
  components: {
    QTable,
    QCard,
    QTr,
    QTd,
    QToggle
  },
  mixins: [Loading],
  props: {
    dataEntidad: Object,
    isNew: Boolean
  },
  data: function () {
    return {
      serviciosEntidad: [],
      pagination: {
        sortBy: 'nivel1',
        descending: true,
        rowsPerPage: 20
      },
      data: this.serviciosEntidad,
      columns: [
        {
          name: 'nivel1',
          label: 'Nivel 1',
          align: 'left',
          field: 'nivel1',
          sortable: true
        },
        {
          name: 'nivel2',
          label: 'Nivel 2',
          align: 'left',
          field: 'nivel2',
          sortable: true
        },
        {
          name: 'nivel3Titulo',
          label: 'Servicio',
          align: 'left',
          field: 'nivel3Titulo',
          sortable: true
        },
        {
          name: 'contratado',
          label: 'Contratado',
          align: 'center',
          field: 'contratado',
          sortable: true
        }
      ],
      filter: ''
    };
  },
  mounted () {
    this.$eventHub.$on(
      'EJECUCION_GUARDAR_SERVS',
      ({ callback, rejected }) => this.saveValues(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('EJECUCION_GUARDAR_SERVS');
  },
  methods: {
    async saveValues (callback, rejected) {
      let arrayServices = [];

      this.serviciosEntidad.forEach((value) => {
        if (value.idServicio !== undefined && value.contratado) {
          arrayServices.push(value.idServicio);
        }
      });

      let dataArray = null;
      let result = {
        data: null,
        status: false
      };

      if (this.isNew) {
        dataArray = {
          id: this.dataEntidad.id,
          serviciosList: arrayServices
        };
        result = await this.saveNewApp(dataArray);
      } else {
        dataArray = {
          id: this.dataEntidad.id,
          name: this.dataEntidad.name,
          visible: this.dataEntidad.visible,
          digitalServices: arrayServices,
          titleIndicator: this.dataEntidad.titleIndicator,
          titleService: this.dataEntidad.titleService
        };
        result = await this.saveUpdate(dataArray);
      }

      if (result.status) {
        callback(result);
      } else {
        rejected(result);
      }
    },
    async saveNewApp (dataArray) {
      let responseData = null;
      let requestRelationship = {
        controller: '/Entidad/' + dataArray.id + '/servicio-relationship',
        filter: {},
        body: dataArray.serviciosList
      };

      await this.$store
        .dispatch('PF/postSuit', requestRelationship)
        .then((response) => {
          this.idEntidad = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });

      return responseData;
    },
    async saveUpdate (dataArray) {
      let request = {
        controller: '/Entidad?id=' + dataArray.id,
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
          this.$router.push({ name: 'Entidades' });
        });

      return responseData;
    }
  },
  watch: {
    isNew: {
      handler: function () {
        this.new = this.isNew;
      },
      immediate: true
    },
    dataEntidad: {
      handler: function () {
        if (this.dataEntidad !== {}) {
          this.serviciosEntidad = this.dataEntidad.listSignedServiceResponses;
        }
      },
      immediate: true
    }
  }
};
</script>
